<script setup lang="ts">
import BsNormalCard from '@/legacy/components/NormalCard.vue'
import { getVueAssetImagePath } from '@/lib/utils'

defineProps({
	info: {
		type: Object,
		require: true,
	},
	text: {
		type: Object,
	},
})
</script>

<template>
	<div>
		<BsNormalCard>
			<template #content>
				<div class="bs-user-contribution__credit">
					<div class="bs-user-contribution__credit__icon__wrap">
						<img
							:src="`${getVueAssetImagePath('coins.png')}`"
							:srcset="`
								${getVueAssetImagePath('coins.png')} 1x,
								${getVueAssetImagePath('coins@2x.png')} 2x,
								${getVueAssetImagePath('coins@3x.png')} 3x
							`"
						/>
					</div>
					<div class="bs-user-contribution__credit__info">
						<div class="bs-user-contribution__credit__info__value">
							{{ info?.remaining }}
						</div>
						<div class="bs-user-contribution__credit__info__value">
							{{ info?.total }}
						</div>
						<div class="bs-user-contribution__credit__info__value">
							{{ info?.convert }}{{ text?.contribution.unitTransform }}
						</div>
					</div>
					<div class="bs-user-contribution__credit__info">
						<div class="bs-user-contribution__credit__info__text">
							{{ text?.contribution.total }}
						</div>
						<div class="bs-user-contribution__credit__info__text">
							{{ text?.contribution.totalEarn }}
						</div>
						<div class="bs-user-contribution__credit__info__text">
							{{ text?.contribution.convertCredit }}
						</div>
					</div>
				</div>
			</template>
		</BsNormalCard>
		<div class="bs-user-contribution__detail__title">
			{{ text?.contribution.detail }}
		</div>
		<BsNormalCard>
			<template #content>
				<div class="bs-user-contribution__detail">
					<div class="bs-user-contribution__detail__row">
						<span class="bs-user-contribution__detail__row__title">
							{{ text?.contribution.liked }}
						</span>
						<span class="bs-user-contribution__detail__row__text">
							{{ info?.liked }} {{ text?.contribution.unit }}
						</span>
					</div>
					<div class="bs-user-contribution__detail__row">
						<span class="bs-user-contribution__detail__row__title">
							{{ text?.contribution.bookmarked }}
						</span>
						<span class="bs-user-contribution__detail__row__text">
							{{ info?.bookmarked }} {{ text?.contribution.unit }}
						</span>
					</div>
					<div class="bs-user-contribution__detail__row">
						<span class="bs-user-contribution__detail__row__title">
							{{ text?.contribution.publish }}
						</span>
						<span class="bs-user-contribution__detail__row__text">
							{{ info?.publish }} {{ text?.contribution.unit }}
						</span>
					</div>
					<div class="bs-user-contribution__detail__row">
						<span class="bs-user-contribution__detail__row__title">
							{{ text?.contribution.welcome }}
						</span>
						<span class="bs-user-contribution__detail__row__text">
							{{ info?.welcome }} {{ text?.contribution.unit }}
						</span>
					</div>
					<div class="bs-user-contribution__detail__row">
						<span class="bs-user-contribution__detail__row__title">
							{{ text?.contribution.event }}
						</span>
						<span class="bs-user-contribution__detail__row__text">
							{{ info?.event }} {{ text?.contribution.unit }}
						</span>
					</div>
				</div>
			</template>
		</BsNormalCard>
	</div>
</template>
